export default __webpack_public_path__ + "static/media/58.3f9942ea.jpeg";